<template>
  <div>
    <div ref="btn">
      <slot />
    </div>
    <div v-if="showIcon">
      <div class="relative z-0">
        <div
          class="absolute"
          :style="iconStyle"
        >
          <MaterialIcon
            v-if="icon"
            :icon="icon"
            class="elevation-3 item-fill flex size-4 items-center justify-center rounded-full bg-white text-xs"
          />
        </div>
      </div>
      <div class="relative z-20">
        <div
          ref="iconDiv"
          class="absolute"
          :style="iconStyle"
        >
          <MaterialIcon
            v-if="icon && tooltip"
            v-tooltip="$t(tooltip?.content)"
            :icon
            :color="iconColor ?? 'green-500'"
            class="item-fill flex size-4 items-center justify-center rounded-full bg-white text-xs"
          />
          <MaterialIcon
            v-else-if="icon"
            :icon
            :color="iconColor ?? 'green-500'"
            class="item-fill flex size-4 items-center justify-center rounded-full bg-white text-xs"
          />
          <Spinner
            v-else
            class="elevation-3 item-fill flex size-4 items-center justify-center rounded-full bg-white text-xs"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const { showIcon = true } = defineProps<{
  showIcon?: boolean
  icon?: string
  iconColor?: string
  tooltip?: {
    content: string
  }
}>()

const btn = ref<HTMLElement>()
const iconDiv = ref<HTMLElement>()

const iconStyle = computed(() => {
  if (!btn.value || !iconDiv.value) return {}

  const btnRadius = getRadius(btn.value)
  const iconRadius = getRadius(iconDiv.value)

  const iconCenter = btnRadius * (1 - 1 / Math.SQRT2)
  const offset = iconCenter - iconRadius

  return { right: `${offset}px`, bottom: `${offset}px` }
})

function getRadius(ele: HTMLElement) {
  return parseInt(getComputedStyle(ele).width) / 2
}
</script>
